import { render, staticRenderFns } from "./ExchangeViewForm.vue?vue&type=template&id=5310e99c&"
import script from "./ExchangeViewForm.vue?vue&type=script&lang=js&"
export * from "./ExchangeViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports